import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createIncidencia, getComunidades, getProveedores } from '../services/api';
import { useToast } from '../components/Toast';
import FileDropZone from '../components/FileDropZone';
import './NuevaIncidencia.css';

function NuevaIncidencia() {
  const navigate = useNavigate();
  const toast = useToast();
  const [formData, setFormData] = useState({
    titulo: '', descripcion: '', categoria: 'Otros', prioridad: 'media', ubicacion: '', comunidad_id: '', proveedor_id: ''
  });
  const [imagenes, setImagenes] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comunidades, setComunidades] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const userData = JSON.parse(userStr);
      setUser(userData);
      if (userData.rol === 'administrador') {
        getComunidades().then(res => setComunidades(res.data)).catch(console.error);
      }
      if (userData.rol === 'presidente' && userData.comunidad_id) {
        getProveedores(userData.comunidad_id).then(res => setProveedores(res.data)).catch(console.error);
      }
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'comunidad_id') {
      setFormData({ ...formData, comunidad_id: value, proveedor_id: '' });
      if (value) {
        getProveedores(value).then(res => setProveedores(res.data)).catch(console.error);
      } else {
        setProveedores([]);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFilesSelected = (newFiles) => {
    const allFiles = [...imagenes, ...newFiles];
    if (allFiles.length > 5) {
      toast.warning('Máximo 5 imágenes permitidas');
      const limited = allFiles.slice(0, 5);
      setImagenes(limited);
      const urls = limited.map(file => URL.createObjectURL(file));
      setPreviewUrls(urls);
      return;
    }
    setImagenes(allFiles);
    const urls = allFiles.map(file => URL.createObjectURL(file));
    setPreviewUrls(urls);
  };

  const handleImagenesChange = (e) => {
    const newFiles = Array.from(e.target.files);
    handleFilesSelected(newFiles);
    e.target.value = '';
  };

  const removeImage = (index) => {
    const newImagenes = imagenes.filter((_, i) => i !== index);
    const newPreviews = previewUrls.filter((_, i) => i !== index);
    setImagenes(newImagenes);
    setPreviewUrls(newPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    Object.keys(formData).forEach(key => {
      if (formData[key]) data.append(key, formData[key]);
    });

    // Agregar múltiples imágenes
    imagenes.forEach((imagen) => {
      data.append('imagenes', imagen);
    });

    try {
      await createIncidencia(data);
      toast.success('¡Incidencia creada correctamente!');
      navigate('/incidencias');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al crear incidencia. Por favor, verifica los datos.');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container nueva-incidencia-page">
      <h1 className="nueva-incidencia-title">🔧 Nueva Incidencia</h1>
      <form onSubmit={handleSubmit} className="card nueva-incidencia-card">
        <div className="form-group float-group">
          <input type="text" name="titulo" className="form-control float-input" value={formData.titulo} onChange={handleChange} required placeholder=" " />
          <label className="float-label">Título *</label>
        </div>
        <div className="form-group float-group">
          <textarea name="descripcion" className="form-control float-input" value={formData.descripcion} onChange={handleChange} required rows="5" placeholder=" " />
          <label className="float-label">Descripción *</label>
        </div>
        <div className="grid grid-2">
          <div className="form-group">
            <label className="form-label">Categoría</label>
            <select name="categoria" className="form-control" value={formData.categoria} onChange={handleChange}>
              <option value="Fontanería">Fontanería</option>
              <option value="Electricidad">Electricidad</option>
              <option value="Ascensor">Ascensor</option>
              <option value="Limpieza">Limpieza</option>
              <option value="Seguridad">Seguridad</option>
              <option value="Otros">Otros</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Prioridad</label>
            <select name="prioridad" className="form-control" value={formData.prioridad} onChange={handleChange}>
              <option value="baja">Baja</option>
              <option value="media">Media</option>
              <option value="alta">Alta</option>
            </select>
          </div>
        </div>
        {user?.rol === 'administrador' && (
          <div className="form-group">
            <label className="form-label">Comunidad *</label>
            <select name="comunidad_id" className="form-control" value={formData.comunidad_id} onChange={handleChange} required>
              <option value="">Selecciona una comunidad</option>
              {comunidades.map(com => (
                <option key={com.id} value={com.id}>{com.nombre}</option>
              ))}
            </select>
          </div>
        )}
        <div className="form-group float-group">
          <input type="text" name="ubicacion" className="form-control float-input" value={formData.ubicacion} onChange={handleChange} placeholder=" " />
          <label className="float-label">Ubicación <span style={{fontWeight:400,opacity:0.7,fontSize:'12px'}}>(ej: Portal 2, 3º piso)</span></label>
        </div>
        {(user?.rol === 'administrador' || user?.rol === 'presidente') && proveedores.length > 0 && (
          <div className="form-group">
            <label className="form-label">Proveedor (opcional)</label>
            <select name="proveedor_id" className="form-control" value={formData.proveedor_id} onChange={handleChange}>
              <option value="">Sin proveedor</option>
              {proveedores.map(p => (
                <option key={p.id} value={p.id}>{p.nombre}{p.servicio ? ` - ${p.servicio}` : ''}</option>
              ))}
            </select>
          </div>
        )}
        <div className="form-group">
          <label className="form-label">Imágenes (máx. 5)</label>
          
          {/* Drag & Drop Zone */}
          {imagenes.length < 5 && (
            <div className="nueva-incidencia-dropzone-wrap">
              <FileDropZone
                onFilesSelected={handleFilesSelected}
                maxFiles={5 - imagenes.length}
                multiple={true}
              />
            </div>
          )}



          {/* Previsualizaciones */}
          {previewUrls.length > 0 && (
            <div className="nueva-incidencia-preview-grid">
              {previewUrls.map((url, index) => (
                <div key={index} className="nueva-incidencia-preview-item nueva-incidencia-preview-item--enter" style={{animationDelay: `${index * 60}ms`}}>
                  <img src={url} alt={`Preview ${index + 1}`} className="nueva-incidencia-preview-image" />
                  <button
                    type="button"
                    onClick={() => removeImage(index)}
                    className="nueva-incidencia-preview-remove"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="nueva-incidencia-actions">
          <button type="button" onClick={() => navigate('/incidencias')} className="btn btn-outline">Cancelar</button>
          <button type="submit" disabled={loading} className="btn btn-primary">{loading ? 'Creando...' : 'Crear Incidencia'}</button>
        </div>
      </form>
    </div>
  );
}

export default NuevaIncidencia;
